import { inject, OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  faCalendar,
  faClock,
  faCoffee,
  faSignature,
  faUser,
  faUserPlus,
  faWarehouse,
} from '@fortawesome/free-solid-svg-icons';
import { PannelloDashboard } from 'src/app/models/pannello-dashboard';
import { Parametri } from 'src/app/models/parametri';
import { TipiArticoli } from 'src/app/models/tipi-articoli';
import { DafirmareGridViewComponent } from 'src/app/shared/components/grid/dafirmare-grid-view/dafirmare-grid-view.component';
import { NavigatorService } from 'src/app/shared/services/navigator.service';
import { ParametriService } from 'src/app/shared/services/parametri.service';
import { SettingsBackendService } from 'src/app/shared/services/settings-backend.service';
import { TipiArticoliService } from 'src/app/shared/services/tipi-articoli.service';
import { ConvertError } from 'src/app/utils/gestione-errori';
import { MovimentoArticoliService } from 'src/app/shared/services/movimento-articoli.service';
import moment from 'moment';
import { PARAMETRI_GIORNI_PRE_ALERT_ARTICOLI } from 'src/app/consts/const';
import { Articoli } from 'src/app/models/articoli';
import { Dipendente } from 'src/app/models/dipendente';
import { ArticoliService } from 'src/app/shared/services/articoli.service';
import { DipendentiService } from 'src/app/shared/services/dipendenti.service';
import { MovimentiMagazzinoService } from 'src/app/shared/services/movimenti-magazzino.service';
import { DxButtonComponent, DxLookupComponent } from 'devextreme-angular';
import { DxoDropDownOptionsComponent } from 'devextreme-angular/ui/nested';
import { ArticoliConsegnatiScadenzeCompactComponent } from 'src/app/shared/components/articoli/articoli-consegnati-scadenze-compact/articoli-consegnati-scadenze-compact.component';
import { GridArticoliGiacenzeCompactComponent } from 'src/app/shared/components/articoli/grid-articoli-giacenze-compact/grid-articoli-giacenze-compact.component';
import { GridScadenzeDipendentiCompactComponent } from 'src/app/shared/components/dipendenti/grid-scadenze-dipendenti-compact/grid-scadenze-dipendenti-compact.component';

@Component({
  templateUrl: 'home.component.html',
  styleUrls: ['./home.component.scss'],
  imports: [
    DafirmareGridViewComponent,
    FontAwesomeModule,
    DxButtonComponent,
    DxoDropDownOptionsComponent,
    DxLookupComponent,
    ArticoliConsegnatiScadenzeCompactComponent,
    GridArticoliGiacenzeCompactComponent,
    GridScadenzeDipendentiCompactComponent
  ],
  standalone: true,
})
export class HomeComponent implements OnInit {
  private settingsBEService = inject(SettingsBackendService);
  private tipoArticoliS = inject(TipiArticoliService);
  private nS = inject(NavigatorService);
  private movS = inject(MovimentoArticoliService);
  private movService = inject(MovimentoArticoliService);
  private movimentiMagazzinoService = inject(MovimentiMagazzinoService);
  private dipendentiService = inject(DipendentiService);
  private parametriService = inject(ParametriService);
  private articoliService = inject(ArticoliService);

  pannelliDashboard: PannelloDashboard[];
  listTipologieArticoli: TipiArticoli[];
  faCoffee = faCoffee;
  faUser = faUser;
  faSignature = faSignature;
  faMagazzino = faWarehouse;
  faUserPlus = faUserPlus;
  faCalendar = faCalendar;
  faClock = faClock;
  nDaFirmare: number;

  consegneList: any[];
  listConsegneAlert: any[];
  consegneScadute: any[];
  consegneProssimeAllaScadenza: any[];
  articolo: Articoli;
  numConsegneProssimeAllaScadenza: number;
  numConsegneScadute: number;
  giorniPreAlertArticoli: number = 2;

  parametro: Parametri;
  listDipendenti: Dipendente[] = [];
  numDipAttivi: number;

  listArticoli: Articoli[] = [];
  numArticoliAttivi: number = 0;
  numArticoliSottoscorta: number = 0;
  numArticoliEsauriti: number = 0;

  selectedEmployee: any;

  //Giacenze progressive
  daData: Date;
  aData: Date;
  giacenzeProgressive: any;

  //ArticoliAlert (esauriti/sottoscorta)
  listArticoliAlert: any;

  constructor() {
    this.settingsBEService.getLayoutSettings().subscribe((layoutSettings) => {
      this.pannelliDashboard = layoutSettings.pannelliDashboard;
    });

    //Lista Articoli
    //this.tipoArticoliS.list().subscribe((dati)=> {
    //  this.listTipologieArticoli = dati;
    // // console.log('Tipologie articoli: ' + dati);
    //})

    //this.movS.listMovimentiArticoli.subscribe((dati) =>{
    //  this.nDaFirmare = dati?.filter(m => m.firmato == false).length;;
    //});

    this.getParametro();
  }

  /*
  get nDaFirmare(): number{
    return this.movS.listMovimentiDpi?.filter(m => m.firmato == false).length;
  } */

  ngOnInit() {
    this.loadDipendenti();
    this.loadConsegne();
    this.loadArticoli();
  }

  goToDaFirmare() {
    this.nS.goToDaFirmare();
  }

  getParametro() {
    this.parametriService.get(PARAMETRI_GIORNI_PRE_ALERT_ARTICOLI).subscribe({
      next: (res) => {
        this.parametro = res;
        this.giorniPreAlertArticoli = this.parametro.valNum;
      },
      error: (error) => {
        ConvertError(error, 'Errore recupero parametro');
      },
    });
  }

  loadDipendenti() {
    this.dipendentiService.listTemp().subscribe({
      next: (res) => {
        this.listDipendenti = res.sort((a, b) =>
          a.nominativo < b.nominativo ? -1 : 1,
        );
        this.numDipAttivi = this.listDipendenti.filter((x) => x.attivo).length;
      }
    });
  }

  loadArticoli() {
    this.articoliService.listTemp(true).subscribe({
      next: (res) => {
        this.listArticoli = res.sort((a, b) =>
          a.descrizione < b.descrizione ? -1 : 1,
        );
        this.numArticoliAttivi = this.listArticoli.length;

        this.listArticoliAlert = this.listArticoli.filter(
          (x) =>
            x.attivo &&
            x.giacenza != null &&
            (x.giacenza <= 0 ||
              (x.giacenza > 0 && x.giacenza <= x.scortaMinima)),
        );

        this.numArticoliEsauriti = this.listArticoli.filter(
          (x) => x.attivo && x.giacenza != null && x.giacenza <= 0,
        ).length;
        this.numArticoliSottoscorta = this.listArticoli.filter(
          (x) =>
            x.attivo &&
            x.giacenza != null &&
            x.giacenza > 0 &&
            x.giacenza < x.scortaMinima,
        ).length;
      },
      error: (error) => {
        ConvertError(error, 'Errore recupero articoli');
      },
    });
  }

  loadConsegne() {
    this.movService.listConsegne(0, 0).subscribe({
      next: (res) => {
        this.consegneList = res.filter(
          (x) => x.dipendenteAttivo && x.articoloAttivo,
        ); // Solo per dipendenti e articoli attivi

        const oggi = moment().format('YYYY-MM-DD'); // data odierna

        // Consegne scadute (datascadenza <= oggi)
        this.consegneScadute = this.consegneList.filter((c: any) => {
          const dataScadenza = moment(c.dataScadenza).format('YYYY-MM-DD');
          //return dataScadenza.isSameOrBefore(oggi, 'day');
          return dataScadenza <= oggi;
        });

        // Consegne prossime alla scadenza (entro x giorni da oggi)
        this.consegneProssimeAllaScadenza = this.consegneList.filter(
          (c: any) => {
            const dataScadenza = moment(c.dataScadenza).format('YYYY-MM-DD');
            //const diffGiorni = dataScadenza.diff(oggi, 'days');
            const diffGiorni = moment(dataScadenza).diff(moment(oggi), 'days');
            return diffGiorni > 0 && diffGiorni <= this.giorniPreAlertArticoli;
          },
        );

        //Unico le liste
        this.listConsegneAlert = [
          ...this.consegneScadute,
          ...this.consegneProssimeAllaScadenza,
        ];

        this.numConsegneScadute = this.consegneScadute.length;
        this.numConsegneProssimeAllaScadenza =
          this.consegneProssimeAllaScadenza.length;
      },
      error: (error) => {
        ConvertError(error, 'Errore recupero consegne');
      },
    });
  }

  getDisplayExprDipendente(item) {
    if (!item) {
      return '';
    }
    return item.codice + ' - ' + item.nominativo;
  }

  valueChangedDip(data) {
    this.selectedEmployee = data.value;
  }

  goToDipendente(e) {
    this.nS.goToDipedenteDashboard(e);
  }

  getDisplayExprArticolo(item) {
    if (!item) {
      return '';
    }
    return item.codice + ' - ' + item.descrizione;
  }

  goToArticolo(e) {
    this.nS.goToArticoliDashboard(e);
  }
}
